export default __webpack_public_path__ + "static/media/check.8aa632d1.svg";